import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { TimeFormater } from '../helpers/time-formater';
import { GridOptions } from 'ag-grid';

@Component({
  selector: 'app-mes-achat',
  templateUrl: './mes-achat.component.html',
  styleUrls: ['./mes-achat.component.css']
})
export class MesAchatComponent implements OnInit {

  constructor() { }
  model: any = {};
  // res: any;
  loading = false;
  gridOptions;
  givenInstallation;
  rowData: any;
  rowDataFiltred;
  columnDefs = [
    { headerName: 'Piscine', field: 'piscine' },
    { headerName: 'Numero de Ticket', field: 'ticketCode' },
    {
      headerName: 'Date D\'achat', field: 'date_achat'
    },
    {
      headerName: 'utilisé', field: 'date_validation'
    },
    { headerName: 'type', field: 'type', width: 160 }
  ];

  ngOnInit() {
    this.loadLogs();
    this.gridOptions = <GridOptions>{
      columnDefs: this.columnDefs,
      context: {
        componentParent: this
      },
      enableColResize: true
    };
  }
  loadLogs() {
    this.loading = true;
    this.rowData = 
    [{ticketCode:'12435',date_achat:'10/08/2018 10h05',date_validation:'15/08/2018 10h05',type:'ENTRÉE A L’UNITÉ',piscine:'Vallier - 4e'},
    {ticketCode:'43124',date_achat:'05/08/2018 11h05',date_validation:'10/08/2018 10h05',type:'ENTRÉE A L’UNITÉ',piscine:'Bonneveine - 8e'},
    {ticketCode:'98434',date_achat:'10/09/2018 10h05',date_validation:'11/09/2018 10h05',type:'ENTRÉE A L’UNITÉ',piscine:'Vallier - 4e'},
    {ticketCode:'12402',date_achat:'13/01/2019 12h00',date_validation:'14/01/2019 08h00',type:'ENTRÉE A L’UNITÉ',piscine:'Bonneveine - 8e'},
    {ticketCode:'0320',date_achat:'10/12/2018 12h00',date_validation:'13/12/2018 12h00',type:'ENTRÉE A L’UNITÉ',piscine:'Vallier - 4e'},
    {ticketCode:'56322',date_achat:'13/01/2019 12h00',date_validation:'13/01/2019 12h00',type:'ENTRÉE A L’UNITÉ',piscine:'Vallier - 4e'}
    ]
  }
  filter() {
    let flt =this.model.filter;
    if (flt) {
      this.rowDataFiltred = this.rowData.filter(function (element) {
        for (let value of Object.values(element)) {
          var str: String= new String(value).toLocaleUpperCase( );
          if(value !=null){
              if(str.indexOf(flt.toLocaleUpperCase( )) >= 0)return element;
            
          }
        }
        

      })
    } else {
      this.rowDataFiltred = null;
    }

  }
}
